'use client';

import { useRouter } from 'next/navigation';
import React from 'react';
import { generateRoomId } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';

export default function Page() {
  const router = useRouter();
  const startCall = () => router.push(`/rooms/${generateRoomId()}`);

  return (
    <main className={styles.main} data-lk-theme="default">
      <div className="header" style={{ textAlign: 'center' }}>
        <h1 style={{ margin: 0 }}>Семейный звонок</h1>
        <h2>Видеозвонок для своих: без установки, работает и при слабом интернете.</h2>
      </div>
      <div className={styles.tabContainer}>
        <div className={styles.tabContent}>
          <button className="lk-button" onClick={startCall}>
            Начать звонок
          </button>
          <p style={{ margin: 0, opacity: 0.7, fontSize: '0.9em' }}>
            Перед входом отправьте ссылку на звонок тому, кому звоните.
          </p>
          <a href="/help" style={{ textAlign: 'center', opacity: 0.7, fontSize: '0.9em' }}>
            Как установить на телефон и пользоваться
          </a>
        </div>
      </div>
    </main>
  );
}
